import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "custom-scroll"
};
const _hoisted_2 = {
  class: "page-invitation"
};
const _hoisted_3 = {
  class: "inner"
};
const _hoisted_4 = {
  class: "share-box"
};
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = {
  class: "invite-qrcode"
};
const _hoisted_7 = {
  class: "invite-url"
};
const _hoisted_8 = {
  class: "invite-stats"
};
const _hoisted_9 = {
  class: "item-box yellow"
};
const _hoisted_10 = {
  class: "item-info"
};
const _hoisted_11 = {
  class: "num"
};
const _hoisted_12 = {
  class: "item-box blue"
};
const _hoisted_13 = {
  class: "item-info"
};
const _hoisted_14 = {
  class: "num"
};
const _hoisted_15 = {
  class: "item-box green"
};
const _hoisted_16 = {
  class: "item-info"
};
const _hoisted_17 = {
  class: "num"
};
const _hoisted_18 = {
  class: "box-card"
};
const _hoisted_19 = {
  class: "invite-logs"
};
import { onMounted, ref } from "vue";
import QRCode from "qrcode";
import { httpGet } from "@/utils/http";
import { ElMessage } from "element-plus";
import Clipboard from "clipboard";
import InviteList from "@/components/InviteList.vue";
import { checkSession, getSystemInfo } from "@/store/cache";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'Invitation',
  setup(__props) {
    const inviteURL = ref("");
    const qrImg = ref("/images/wx.png");
    const invitePower = ref(0);
    const hits = ref(0);
    const regNum = ref(0);
    const rate = ref(0);
    const isLogin = ref(false);
    const store = useSharedStore();
    onMounted(() => {
      initData();

      // 复制链接
      const clipboard = new Clipboard(".copy-link");
      clipboard.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.on("error", () => {
        ElMessage.error("复制失败！");
      });
    });
    const initData = () => {
      checkSession().then(() => {
        isLogin.value = true;
        httpGet("/invite/code").then(res => {
          const text = `${location.protocol}//${location.host}/register?invite_code=${res.data.code}`;
          hits.value = res.data["hits"];
          regNum.value = res.data["reg_num"];
          if (hits.value > 0) {
            rate.value = (regNum.value / hits.value * 100).toFixed(2);
          }
          QRCode.toDataURL(text, {
            width: 400,
            height: 400,
            margin: 2
          }, (error, url) => {
            if (error) {
              console.error(error);
            } else {
              qrImg.value = url;
            }
          });
          inviteURL.value = text;
        }).catch(e => {
          ElMessage.error("获取邀请码失败：" + e.message);
        });
        getSystemInfo().then(res => {
          invitePower.value = res.data["invite_power"];
        }).catch(e => {
          ElMessage.error("获取系统配置失败：" + e.message);
        });
      }).catch(() => {
        store.setShowLoginDialog(true);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[10] || (_cache[10] = _createElementVNode("h2", {
        class: "text-2xl p-4 font-bold"
      }, "会员推广计划", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[0] || (_cache[0] = _createTextVNode(" 我们非常欢迎您把此应用分享给您身边的朋友，分享成功注册后您和被邀请人都将获得 ")), _createElementVNode("strong", null, _toDisplayString(invitePower.value), 1), _cache[1] || (_cache[1] = _createTextVNode(" 算力额度作为奖励。 你可以保存下面的二维码或者直接复制分享您的专属推广链接发送给微信好友。 "))]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_image, {
        src: qrImg.value
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(inviteURL.value), 1), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        class: "copy-link",
        "data-clipboard-text": inviteURL.value
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("复制链接")])),
        _: 1
      }, 8, ["data-clipboard-text"])])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_row, {
            gutter: 10
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 10
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("div", {
                class: "item-icon"
              }, [_createElementVNode("i", {
                class: "iconfont icon-role"
              })], -1)])),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 14
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(hits.value), 1), _cache[4] || (_cache[4] = _createElementVNode("div", {
                class: "text"
              }, "点击量", -1))])]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_row, {
            gutter: 10
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 10
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("div", {
                class: "item-icon"
              }, [_createElementVNode("i", {
                class: "iconfont icon-order"
              })], -1)])),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 14
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(regNum.value), 1), _cache[6] || (_cache[6] = _createElementVNode("div", {
                class: "text"
              }, "注册量", -1))])]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_row, {
            gutter: 10
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 10
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("div", {
                class: "item-icon"
              }, [_createElementVNode("i", {
                class: "iconfont icon-chart"
              })], -1)])),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 14
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(rate.value) + "%", 1), _cache[8] || (_cache[8] = _createElementVNode("div", {
                class: "text"
              }, "转化率", -1))])]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_18, [_cache[9] || (_cache[9] = _createElementVNode("h2", {
        class: "text-xl pb-4"
      }, "您推荐的用户", -1)), _createElementVNode("div", _hoisted_19, [isLogin.value ? (_openBlock(), _createBlock(InviteList, {
        key: 0
      })) : _createCommentVNode("", true)])])])])]);
    };
  }
};